import { NgModule } from '@angular/core';
import { OvGenericModule } from '@ov-suite/ui';
import { FactoryArea } from '@ov-suite/models-admin';

@NgModule({
  imports: [
    OvGenericModule.forRoot({
      entity: FactoryArea,
      api: 'adminlink',
      createTitle: 'Factory Area',
      route: ['factory-area'],
      tableTitle: 'Factory Area',
      tabs: [
        {
          path: '/factory',
          title: 'Factories & Warehouses',
        },
        {
          path: '/factory-area',
          title: 'Factory Area',
        },
        {
          path: '/inventory-location',
          title: 'Inventory Location',
        },
      ],
      permissionId: 904,
    }),
  ],
})
export class FactoryAreaModule {}
